/*
 * @Author: Will Keung Lau
 * @Date: 2023-02-05 22:58:26
 * @LastEditors: Will Keung Lau
 * @LastEditTime: 2025-04-07 11:18:14
 * @Description:  头部注释
 */

export const globalData: Record<string, any> = {};
type iAction = 'updateItem' | 'remove' | 'refresh';
type iDefaultKey = 'USERINFO';


const defaultKey: iDefaultKey = 'USERINFO';

/**
 * 设置缓存
 * @param val 缓存数据
 * @param key 缓存键
 */
export function setCache<T=any>(val: any, key: string = defaultKey): void {
    globalData[key] = val;
    console.log(globalData);
}

/**
 * 更新缓存
 * @param val 更新的数据
 * @param key 缓存键
 */
export function updateCache<T=any>(val: any, key: string = defaultKey): void {
    globalData[key] = { ...globalData[key], ...val };
}

/**
 * 更新缓存操作
 * @param action 操作类型
 * @param key 缓存键
 */
export function updateCacheAction(action: iAction, key: string = defaultKey): void {
    if (globalData[key]) {
        globalData[key].action = action;
    }
}

/**
 * 清除缓存
 * @param key 缓存键
 */
export function clearCache(key: string = defaultKey): void {
    delete globalData[key];
}

/**
 * 获取缓存
 * @param key 缓存键
 * @returns 缓存数据
 */
export function getCache<T=any>(key: string = defaultKey): T | null {
    console.log(globalData[key],key,globalData,7777);
    return globalData[key] || null;
}